import '../importar/styleGlobal.css';
import clsx from "clsx";
import { IEmpresas } from '../../interfaces/IEmpresas';
import { useEffect, useState } from 'react';
import { FormikProps } from 'formik';
import { IClientes } from '../../interfaces/IClientes';
import ClientesService from '../../services/ClientesService';
import { LISTA_ESTADOS, MASCARA_CEP, MASCARA_CNPJ, MASCARA_DATA, MASCARA_TELEFONE } from '../../utils/Constants';
import MaskedInput from 'react-text-mask';
import { IMunicipioIBGE } from '../../interfaces/IMunicipioIBGE';
import IBGEService from '../../services/IBGEService';
import ReactS3Client from 'react-aws-s3-typescript';
import { configBucket } from '../../utils/S3Utils';

const EmpresasNovoModal = ({ empresa, formikEmpresa: formik, abaSelecionada }: { empresa: IEmpresas | null, formikEmpresa: FormikProps<IEmpresas>, abaSelecionada: string }) => {
    
    const [municipios, setMunicipios] = useState<IMunicipioIBGE[]>([]);
    const [clientes, setClientes] = useState<IClientes[]>([]);
    const [urlFile, setUrlFile] = useState<string>();
    const [loadingFile, setLoadingFile] = useState<boolean>(false);

    useEffect(() => {
        async function preCarregar() {
            formik.resetForm();

            if (empresa !== null) {
                setUrlFile(`https://ecd-files.s3.us-east-2.amazonaws.com/${empresa?.id}.png`)
                const empresaEntries = Object.entries(empresa)

                for (const [key, value] of empresaEntries) {
                    formik.setFieldValue(key, value || '');
                }

                await IBGEService.pesquisarMunicipios(empresa.estado ?? "", x => setMunicipios(x));
            }

            await ClientesService.obterTodos(x => setClientes(x));
        };

        preCarregar();

        // eslint-disable-next-line
    }, [empresa])

    const onChangeFile = async (e: any) => {
        setLoadingFile(true);
        if (e.target.files !== null && e.target.files.length > 0) {
            const file = e.target.files[0] as File;
            const s3 = new ReactS3Client(configBucket);
            const res = await s3.uploadFile(file, `${empresa?.id}`);
            setUrlFile('');
            setUrlFile(res.location);
        }
        setLoadingFile(false);
    }

    return <>
        <div className="col-md-12" style={{ display: abaSelecionada === '1' ? 'flex' : 'none', border: '1px solid #ddd', borderRadius: '5px', padding: '10px' }}>
            <div className="col-md-6" style={{ borderRight: '1px solid #ddd', margin: '0 10px', padding: '0 10px' }}>
                <div className='col-md-12' style={{ marginBottom: '10px' }}>
                    {!loadingFile ? <>
                        <div className='col-md-12'>
                            <label className="form-label">Logo Empresa (Somente PNG)</label>
                        </div>
                        <div className='col-md-12' style={{ marginBottom: '10px' }}>
                            <img src={urlFile} alt="Preview" style={{ width: '50px', height: '50px' }} />
                        </div>
                        <div className='col-md-12'>
                            <input type='file' placeholder='Insira a imagem aqui' accept='image/png' onChange={(e) => onChangeFile(e)} />
                        </div>
                        <div className='col-md-12'>
                            <p style={{ fontSize: '12px', fontStyle: 'italic'}}>não precisa salvar a empresa, ao inserir a imagem já fica salva.</p>
                        </div>
                    </> : 
                    <div className='col-md-12'>
                        <p>Carregando...</p>
                    </div>
                    }
                </div>
                <div style={{ display: 'flex' }}>
                    <div className="col-md-8 importarNovoModal">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">CNPJ</label>
                        <MaskedInput mask={MASCARA_CNPJ} {...formik.getFieldProps('cnpj')} placeholder="00.000.000/0000-00" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.cnpj && formik.errors.cnpj,
                            },
                            {
                                'is-valid': formik.touched.cnpj && !formik.errors.cnpj,
                            }
                        )} id="form-cnpj" />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">Data de Abertura</label>
                        <MaskedInput mask={MASCARA_DATA} {...formik.getFieldProps('dataAberturaString')} placeholder="00/00/0000" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.dataAberturaString && formik.errors.dataAberturaString,
                            },
                            {
                                'is-valid': formik.touched.dataAberturaString && !formik.errors.dataAberturaString,
                            }
                        )} id="form-dataAbertura" />
                    </div>
                </div>
                <div className="col-md-12">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">Razão Social</label>
                    <input {...formik.getFieldProps('razaoSocial')} placeholder="Digite algo" type="text" className={clsx(
                        'form-control',
                        {
                            'is-invalid': formik.touched.razaoSocial && formik.errors.razaoSocial,
                        },
                        {
                            'is-valid': formik.touched.razaoSocial && !formik.errors.razaoSocial,
                        }
                    )} id="form-razaoSocial" />
                </div>
                <div style={{ display: 'flex' }}>
                    <div className="col-md-9 importarNovoModal">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">Nome Fantasia</label>
                        <input {...formik.getFieldProps('nomeFantasia')} placeholder="Digite algo" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.nomeFantasia && formik.errors.nomeFantasia,
                            },
                            {
                                'is-valid': formik.touched.nomeFantasia && !formik.errors.nomeFantasia,
                            }
                        )} id="form-nomeFantasia" />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">Porte</label>
                        <input {...formik.getFieldProps('porte')} placeholder="Digite algo" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.porte && formik.errors.porte,
                            },
                            {
                                'is-valid': formik.touched.porte && !formik.errors.porte,
                            }
                        )} id="form-porte" />
                    </div>
                </div>
                <div className="col-md-12">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">Código e Descrição da Atividade Principal</label>
                    <input {...formik.getFieldProps('atividadePrincipal')} placeholder="Digite algo" type="text" className={clsx(
                        'form-control',
                        {
                            'is-invalid': formik.touched.atividadePrincipal && formik.errors.atividadePrincipal,
                        },
                        {
                            'is-valid': formik.touched.atividadePrincipal && !formik.errors.atividadePrincipal,
                        }
                    )} id="form-atividadePrincipal" />
                </div>
                <div className="col-md-12">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">Código e Descrição da Atividade Secundária</label>
                    <input {...formik.getFieldProps('atividadeSecundaria')} placeholder="Digite algo" type="text" className={clsx(
                        'form-control',
                        {
                            'is-invalid': formik.touched.atividadeSecundaria && formik.errors.atividadeSecundaria,
                        },
                        {
                            'is-valid': formik.touched.atividadeSecundaria && !formik.errors.atividadeSecundaria,
                        }
                    )} id="form-atividadeSecundaria" />
                </div>
                <div style={{ display: 'flex' }}>
                    <div className="col-md-9 importarNovoModal">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">Endereço</label>
                        <input {...formik.getFieldProps('endereco')} placeholder="Digite algo" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.endereco && formik.errors.endereco,
                            },
                            {
                                'is-valid': formik.touched.endereco && !formik.errors.endereco,
                            }
                        )} id="form-endereco" />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">Número</label>
                        <input {...formik.getFieldProps('numero')} placeholder="Digite algo" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.numero && formik.errors.numero,
                            },
                            {
                                'is-valid': formik.touched.numero && !formik.errors.numero,
                            }
                        )} id="form-numero" />
                    </div>
                </div>
                <div style={{ display: 'flex' }}>
                    <div className="col-md-9 importarNovoModal">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">Complemento</label>
                        <input {...formik.getFieldProps('complemento')} placeholder="Digite algo" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.complemento && formik.errors.complemento,
                            },
                            {
                                'is-valid': formik.touched.complemento && !formik.errors.complemento,
                            }
                        )} id="form-complemento" />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">CEP</label>
                        <MaskedInput mask={MASCARA_CEP} {...formik.getFieldProps('cep')} placeholder="00000-000" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.cep && formik.errors.cep,
                            },
                            {
                                'is-valid': formik.touched.cep && !formik.errors.cep,
                            }
                        )} id="form-cep" />
                    </div>
                </div>
            </div>

            <div className="col-md-6">
                <div style={{ display: 'flex' }}>
                    <div className="col-md-5 importarNovoModal">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">Bairro</label>
                        <input {...formik.getFieldProps('bairro')} placeholder="Digite algo" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.bairro && formik.errors.bairro,
                            },
                            {
                                'is-valid': formik.touched.bairro && !formik.errors.bairro,
                            }
                        )} id="form-bairro" />
                    </div>
                    <div className="col-md-4 importarNovoModal">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">Munícipio </label>
                        <select disabled={formik.values.estado === ''} {...formik.getFieldProps('municipio')} className={clsx(
                            'form-select',
                            {
                                'is-invalid': formik.touched.municipio && formik.errors.municipio,
                            },
                            {
                                'is-valid': formik.touched.municipio && !formik.errors.municipio,
                            }
                        )} id="form-municipio" >
                            <option value="" hidden>Selecione</option>
                            {
                                municipios.map((x, index) => <option key={index} value={x.nome}>{x.nome}</option>)
                            }
                        </select>
                    </div>
                    <div className="col-md-2">
                        <label htmlFor="form-mensagem-tipo" className="form-label required">UF</label>
                        <select {...formik.getFieldProps('estado')} className={clsx(
                        'form-select',
                        {
                        'is-invalid': formik.touched.estado && formik.errors.estado
                        },
                        {
                        'is-valid': formik.touched.estado && !formik.errors.estado
                        }
                        )} id="form-estado" onChange={async e => {
                            await formik.setFieldValue('estado', e.target.value);
                            if (e.target.value) {
                                await IBGEService.pesquisarMunicipios(e.target.value, x => setMunicipios(x));
                            }
                        }}>
                            <option value="" hidden>UF</option>
                            {
                                LISTA_ESTADOS.map((x, index) => <option key={index}>{x}</option>)
                            }
                        </select>
                    </div>
                </div>
                <div className="col-md-11">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">E-mail</label>
                    <input {...formik.getFieldProps('email')} placeholder="example@exemple.com" type="text" className={clsx(
                        'form-control',
                        {
                            'is-invalid': formik.touched.email && formik.errors.email,
                        },
                        {
                            'is-valid': formik.touched.email && !formik.errors.email,
                        }
                    )} id="form-email" />
                </div>
                <div style={{ display: 'flex' }}>
                    <div className="col-md-6 importarNovoModal">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">Telefone</label>
                        <MaskedInput mask={MASCARA_TELEFONE} {...formik.getFieldProps('telefone')} placeholder="(00)0000-0000" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.telefone && formik.errors.telefone,
                            },
                            {
                                'is-valid': formik.touched.telefone && !formik.errors.telefone,
                            }
                        )} id="form-telefone" />
                    </div>
                    <div className="col-md-5">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">Telefone Adicional</label>
                        <MaskedInput mask={MASCARA_TELEFONE} {...formik.getFieldProps('telefoneAdicional')} placeholder="(00)0000-0000" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.telefoneAdicional && formik.errors.telefoneAdicional,
                            },
                            {
                                'is-valid': formik.touched.telefoneAdicional && !formik.errors.telefoneAdicional,
                            }
                        )} id="form-telAdcional" />
                    </div>
                </div>
                <div style={{ display: 'flex' }}>
                    <div className="col-md-8 importarNovoModal">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">Situação Cadastral</label>
                        <input {...formik.getFieldProps('situacaoCadastral')} placeholder="Digite algo" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.situacaoCadastral && formik.errors.situacaoCadastral,
                            },
                            {
                                'is-valid': formik.touched.situacaoCadastral && !formik.errors.situacaoCadastral,
                            }
                        )} id="form-situacaoCadastral" />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">Data da Situação Cad.</label>
                        <MaskedInput mask={MASCARA_DATA} {...formik.getFieldProps('dataSituacaoCadastralString')} placeholder="00/00/0000" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.dataSituacaoCadastralString && formik.errors.dataSituacaoCadastralString,
                            },
                            {
                                'is-valid': formik.touched.dataSituacaoCadastralString && !formik.errors.dataSituacaoCadastralString,
                            }
                        )} id="form-dataSituacao" />
                    </div>
                </div>
                <div className="col-md-11">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">Motivo da Situação Cadastral</label>
                    <input {...formik.getFieldProps('motivoSituacaoCadastral')} placeholder="Digite algo" type="text" className={clsx(
                        'form-control',
                        {
                            'is-invalid': formik.touched.motivoSituacaoCadastral && formik.errors.motivoSituacaoCadastral,
                        },
                        {
                            'is-valid': formik.touched.motivoSituacaoCadastral && !formik.errors.motivoSituacaoCadastral,
                        }
                    )} id="form-motivoSituacao" />
                </div>
                <div style={{ display: 'flex' }}>
                    <div className="col-md-8 importarNovoModal">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">Situação Especial</label>
                        <input {...formik.getFieldProps('situacaoEspecial')} placeholder="Digite algo" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.situacaoEspecial && formik.errors.situacaoEspecial,
                            },
                            {
                                'is-valid': formik.touched.situacaoEspecial && !formik.errors.situacaoEspecial,
                            }
                        )} id="form-SsituacaoEsp" />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">Data da Situação Esp.</label>
                        <MaskedInput mask={MASCARA_DATA} {...formik.getFieldProps('dataSituacaoEspecialString')} placeholder="00000-000" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.dataSituacaoEspecialString && formik.errors.dataSituacaoEspecialString,
                            },
                            {
                                'is-valid': formik.touched.dataSituacaoEspecialString && !formik.errors.dataSituacaoEspecialString,
                            }
                        )} id="form-dataSituacao" />
                    </div>
                </div>
                <div className="col-md-11">
                    <label htmlFor="form-cliente" className="form-label">Cliente</label>
                    <select {...formik.getFieldProps('clienteID')} placeholder="UF" className={clsx(
                        'form-select',
                        {
                            'is-invalid': formik.touched.clienteID && formik.errors.clienteID,
                        },
                        {
                            'is-valid': formik.touched.clienteID && !formik.errors.clienteID,
                        }
                    )}  id="form-cliente" onChange={async e => await formik.setFieldValue('clienteID', e.target.value)}>
                        <option value="" hidden>Selecione</option>
                        {
                            clientes.map((x, index) => <option key={index} value={x.id} >{x.razaoSocial}</option>)
                        }
                    </select>
                </div>
            </div>
        </div>
    </>
}

export default EmpresasNovoModal;